<style lang='less' scoped>
@import '../base.less';
</style>
<template>
  <div>
    <!-- SEARCH -->
    <Row>
      <Col span="24">
        <Card class="margin-bottom-10">
          <Form inline>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.username' :placeholder="$t('会员帐号(必需)') "></Input>
              *必需输入用户名查询,才会显示相应打码量数据
            </FormItem>
            <FormItem class="margin-bottom-0">
              <Button type="primary" @click="search">{{ $t('find_button') }}</Button>
            </FormItem>
          </Form>
        </Card>
      </Col>
    </Row>        <!--    -->
    <Row>
      <Col span='24'>

        <Card>


          <span slot="title" style="font-size: 13px;margin-bottom: 2px">
            会员
            <span style="color: red">&nbsp;【{{ searchConf.username ? searchConf.username : '未用户名' }}】</span>自上次提现后第一次充值开始：
            <br/>
            <span style="display: inline-block;color: rgb(113, 168, 237);margin-top: 6px;">
              总打码量要求：
              <span style="color: red">&nbsp;{{ tableShow.allDama ? tableShow.allDama : '0.00' }}</span>  , 实际有效打码量 ：
              <span style="color: red">&nbsp;{{ tableShow.playDama ? tableShow.playDama : '0.00' }}</span>  , 剩余打码量 ：
              <span style="color: red">&nbsp;{{ tableShow.remainDame ? tableShow.remainDame : '0.00' }}</span>  ,
            </span>
          </span>
          <!-- ADDBUTTON -->
          <div class='margin-bottom-15'>
            <Button type='primary' v-has="'financeManage/checkDama/add'" v-if="searchConf.username" @click='preAdd' icon='md-add'>
              {{ $t('add_button') }}
            </Button>
          </div>
          <!-- DATA -->
          <div>
            <Table @on-sort-change="sortChange" :loading='listLoading' :columns='columnsList' :data='tableData'
                   border></Table>
          </div>
          <!-- PAGE -->
          <div class='margin-top-15' style='text-align: center'>
            <Page :total='tableShow.listCount' :current='tableShow.currentPage' :page-size='tableShow.pageSize'
                  @on-change='changePage' @on-page-size-change='changeSize'
                  :page-size-opts='[10,20,30,40,50,100,200,300]' show-elevator show-sizer show-total></Page>
          </div>
        </Card>
      </Col>
    </Row>
    <!-- windowAddEdit -->
    <Modal v-model="windowAdd.show" width="668" :styles="{top: '30px'}" @on-visible-change="windowAddCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ windowAddItem.id ? $t('编辑') : $t('新增') }}</span>
      </p>
      <Form ref="windowAddForm" :rules="windowAddValidate" :model="windowAddItem" :label-width="80"
            label-position="left">
        <FormItem label='充值打码量' prop='in_dama'>
          <Input clearable v-model='windowAddItem.in_dama' :placeholder="$t('请输入充值打码量')"></Input>
        </FormItem>
        <FormItem label='赠送打码量' prop='send_dama'>
          <Input clearable v-model='windowAddItem.send_dama' :placeholder="$t('请输入赠送打码量')"></Input>
        </FormItem>
        <FormItem label='备注' prop='remark'>
          <Input clearable v-model='windowAddItem.remark' :placeholder="$t('请输入备注')"></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="windowAddCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowAddSubmit" :loading="windowAdd.loading">{{ $t('确定') }}</Button>
      </div>
    </Modal>
    <!--    -->
  </div>
</template>
<script>
import {
  getList,
  add,
  del,
  lock,
  getParams,
  changeStatus
} from '@/api/financeManage/checkDama'
import {
  formattingMonth,
  lastMonthDate
} from '@/libs/time'

export default {
  name: 'interface_list',
  data () {
    return {
      timeOptions: {
        shortcuts: [{
          text: '今天',
          value () {
            let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
            let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
            return [a, b]
          }
        },
          {
            text: '昨天',
            value () {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 + 24 * 60 *
                60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '一周',
            value () {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 7)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '本月',
            value () {
              return formattingMonth()
            }
          },
          {
            text: '上月',
            value () {
              return lastMonthDate()
            }
          },
        ]
      },
      columnsList: [{
        title: this.$t('状态'),
        align: 'center',
        minWidth: 100,

        key: 'is_ok',
        render: (h, params) => {
          return h('div', [
            h('span', {
              style: {
                color: params.row.is_ok ? '#ed4014' : '#19be6b',
                borderRadius: '11px',
                border: params.row.is_ok ? '1px solid #ed4014' : '1px solid #19be6b',
                display: 'block',
                height: '25px',
                width: '70%',
                lineHeight: '25px',
                margin: 'auto'
              },
            }, params.row.is_ok ? this.$t('已完成') : this.$t('进行中')),
          ])
        }
      }, {
        title: this.$t('备注'),
        key: 'remark',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('添加时间'),
        key: 'add_time',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('充值'),
        align: 'center',
        minWidth: 120,
        render: (h, params) => {
          let vm = this
          return h('div', [h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('充值金额') + ':' + params.row.in_money), h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('赠送金额') + ':' + params.row.in_money_send),])
        }
      }, {
        title: this.$t('应打码量'),
        align: 'center',
        minWidth: 120,
        render: (h, params) => {
          let vm = this
          return h('div', [h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('充值打码量') + ':' + params.row.in_dama), h('p', {
            style: {
              textAlign: 'left',
              marginLeft: '5px'
            }
          }, this.$t('赠送打码量') + ':' + params.row.send_dama),])
        }
      }, {
        title: this.$t('已打码量'),
        key: 'dama_play',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('剩余打码量'),
        key: 'result',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('操作'),
        align: 'center',
        minWidth: 120,
        render: (h, params) => {
          let vm = this
          return h('div', [h('Button', {
            props: {
              type: 'primary'
            },
            style: {
              margin: '0 5px'
            },
            on: {
              'click': () => {
                this.windowAddItem.id=params.row.id;
                this.windowAddItem.in_dama=params.row.in_dama;
                this.windowAddItem.send_dama=params.row.send_dama;
                this.windowAddItem.remark=params.row.remark;

                this.windowAdd.show=true;
              }
            }
          }, this.$t('编辑')), h('Poptip', {
            props: {
              confirm: true,
              title: this.$t('您确定要删除?'),
              transfer: true
            },
            on: {
              'on-ok': () => {
                console.log(params.row)
                del(params.row.id).then(response => {
                  this.tableData.splice(params.index, 1)
                  this.$Message.success(response.data.msg)
                })
                params.loading = false

              }
            }
          }, [
            h('Button', {
              style: {
                margin: '0 5px'
              },
              props: {
                type: this.$t('error'),
                placement: 'top',
                loading: params.isDeleting
              }
            }, this.$t('删除'))
          ]),])
        }
      },],
      tableData: [],//用于放LIST数据绑定
      tableShow: { //用于分页
        currentPage: 1,
        pageSize: 10,
        listCount: 0,
        allDama: 0,
        playDama: 0,
        remainDame: 0
      },
      searchConf: { searchTime: [],username:'' }, // 搜索字段
      extraParams: [],
      buttonShow: { //按钮状态显示
        edit: true,
        del: true,
        changeStatus: true
      },
      listLoading: false, //显示加载中状态
      //弹窗--------------
      windowAdd: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowAddItem: { //弹窗数据绑定
        id: 0
      },
      windowAddValidate: {//窗口校验规则
      },                            //----------------
    }
  },
  created () {
    let vm = this
    this.searchConf.username = this.$route.params.username ? this.$route.params.username : ''
    vm.getList()
    vm.hasRule('financeManage/checkDama/edit').then(res => {
      vm.buttonShow.edit = res
    })
    vm.hasRule('financeManage/checkDama/del').then(res => {
      vm.buttonShow.del = res
    })
    vm.hasRule('financeManage/checkDama/changeStatus').then(res => {
      vm.buttonShow.changeStatus = res
    })
  },
  mounted () {
    this.getParams()
  },

  methods: {
    preAdd () {
      let vm = this
      this.windowAddItem.id=0;
      this.windowAddItem.in_dama='';
      this.windowAddItem.send_dama='';
      this.windowAddItem.remark='';
      this.windowAdd.show=true;
    },
    getParams () {
      // getParams().then(response => {
      //     this.extraParams = response.data.data
      // })
    },
    changePage (page) {
      this.tableShow.currentPage = page
      this.getList()
    },
    changeSize (size) {
      this.tableShow.pageSize = size
      this.getList()
    },
    search () {
      this.tableShow.currentPage = 1
      this.getList()
    },
    getList () {
      let vm = this
      vm.listLoading = true
      getList({
        page: vm.tableShow.currentPage,
        size: vm.tableShow.pageSize,
        search: vm.searchConf
      }).then(response => {
        vm.tableData = response.data.data.list
        vm.tableShow.listCount = response.data.data.count
        vm.tableShow.allDama = response.data.data.allDama
        vm.tableShow.playDama = response.data.data.playDama
        vm.tableShow.remainDame = response.data.data.remainDame
        vm.listLoading = false
      })
    },

    timeChange (datetimerange) { //时间修改，自动计算尾部时间
      if (datetimerange[0] !== '' && datetimerange[1] !== '') {
        let patt = /00:00:00/
        this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        if (patt.test(datetimerange[1])) {
          datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
          this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        }
      } else {
        this.searchConf.searchTime = []
      }
    },
    sortChange: function ({ column, key, order }) {
      //order值可能为asc,desc,normal
      this.searchConf.order = [key, order]
      if (order == 'normal') {
        this.searchConf.order = []
      }
      this.getList()
    },
    windowAddCancel (data) {
      if (!data) {
        this.windowAddItem.id = 0
        this.$refs['windowAddForm'].resetFields()
        this.windowAdd.show = false
        this.windowAdd.loading = false
        this.windowAdd.index = 0
      }
    }, windowAddSubmit () {
      let vm = this
      vm.$refs['windowAddForm'].validate((valid) => {
        if (valid) {
          vm.windowAdd.loading = true
          vm.windowAddItem.username=vm.searchConf.username
          add(vm.windowAddItem).then(response => {
            vm.$Message.success(response.data.msg)
            vm.getList()
            vm.windowAddCancel()
          }).catch(() => {
            vm.windowAdd.loading = false
          })
        }
      })
    },
  }
}
</script>
